import React, { FormEvent } from 'react';
import { Button, Checkbox, FormControlLabel, TextField, styled } from '@mui/material';
import { Search } from '@mui/icons-material';
import { PackageQueryParams } from './hooks/useFetchPackages';
import FilterBox from 'components/filter-box/FilterBox';

const Filter = styled('form')(({ theme }) => ({
  display: 'grid',
  alignItems: 'center',
  gridTemplateColumns: '300px 100px 100px',
  columnGap: 10,
  rowGap: 15,
  [theme.breakpoints.down('sm')]: {
    gridTemplateColumns: '1fr',
  },
}));

type PackageFilterBoxProps = {
  filter: PackageQueryParams;
  handleChange<K extends keyof PackageQueryParams>(index: K, value: PackageQueryParams[K]): void;
  handleSearch(e?: FormEvent<HTMLFormElement>): void;
  loading: boolean;
};

const PackageFilterBox: React.FC<PackageFilterBoxProps> = ({ filter, loading, handleChange, handleSearch }) => {
  return (
    <FilterBox>
      <Filter onSubmit={handleSearch}>
        <TextField
          fullWidth
          label="Nome"
          placeholder="Digite o nome do pacote"
          value={filter.name}
          autoFocus
          onChange={e => handleChange('name', e.target.value)}
        />

        <FormControlLabel
          control={
            <Checkbox
              checked={filter.active}
              onChange={e => handleChange('active', e.target.checked)}
              color="primary"
            />
          }
          label="Ativos"
        />

        <Button
          type="submit"
          disabled={loading}
          variant="contained"
          color="primary"
          size="small"
          startIcon={<Search />}
        >
          Buscar
        </Button>
      </Filter>
    </FilterBox>
  );
};

export default PackageFilterBox;
